import React from "react";
import "./FooterM.css";

export const FooterM = () => {
  return (
    <div>
      <div className="fParents">
        <div>
          <div className="fDetail">
            <h3>Gaurav Kumar</h3>
            <p className="fa fa-phone"><span style={{marginLeft:"10px"}}>8674825586</span></p>
            <p className="fa fa-envelope" ><span style={{marginLeft:"10px"}}>gauravkr2179@gmail.com</span></p>
          </div>
        </div>
        <div className="colm">
          <div>Social Profile : </div>
          <div className="cIconm">
            <a href="https://github.com/gauravkrs">
              <i className="fa fa-github"></i>
            </a>
            <a href="https://www.linkedin.com/in/gauravkrs/">
              <i className="fa fa-linkedin"></i>
            </a>
            <a href="https://www.instagram.com/gauravkr_217/">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="last">
        <p>
          Made with <span style={{ color: "red" }}>❤</span> by Gaurav
        </p>
      </div>
    </div>
  );
};
